import axios from 'axios';

export default {
    getClientToken(cb, { ClientId, ClientSecret }) {
        axios
            .post('/api/ClientToken', { ClientId, ClientSecret }, {
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    }
};
